import { KeyDict } from "@/types";
import { UserNetworkStats } from "@/types/networkstats";

export class NetworkstatsState {
  userStats: KeyDict<UserNetworkStats> = {} as KeyDict<UserNetworkStats>
}
